import { render } from "./HeroTitle.vue?vue&type=template&id=7640bc7c&scoped=true"
import script from "./HeroTitle.vue?vue&type=script&lang=js"
export * from "./HeroTitle.vue?vue&type=script&lang=js"

import "./HeroTitle.vue?vue&type=style&index=0&id=7640bc7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7640bc7c"]])

export default __exports__